module.exports = __webpack_public_path__ + "application/directives/modal-send-email/modal-send-email.template.html";